import React from 'react';
import { isEmpty } from 'lodash';
import { Controller } from 'react-hook-form';
import { Select } from 'src/components';
import { useGoalsLookup } from 'src/queries/goal';
import COMMON_CONSTANTS from 'common/commonConstants';

const { GOAL_VISIBILITY } = COMMON_CONSTANTS;

const Visibility = ({ control, goalId, setValue }) => {
  const {
    data: { children },
    isFetching: isFetchingGoalsLookup,
    isError: isErrorGoalsLookup
  } = useGoalsLookup(
    {
      baseId: goalId
    },
    {
      lookup: {
        direction: 'down'
      }
    },
    { enabled: Boolean(goalId) }
  );

  const isFetching = isFetchingGoalsLookup;
  const isError = isErrorGoalsLookup;
  const isReady = !isFetching && !isError;

  if (!isReady) {
    return null;
  }

  const hasSubgoals = !isEmpty(children);
  const options = [
    {
      label: 'Default',
      underlabel:
        'Only you and your manager(s) can see progress updates, other team members can see this goal title and can assign subgoals to it.',
      value: GOAL_VISIBILITY.DEFAULT
    },

    ...(hasSubgoals
      ? []
      : [
        {
          label: 'Restricted',
          underlabel:
              'Only you and your manager(s) can see this goal and associated progress updates. This goal cannot have subgoals.',
          value: GOAL_VISIBILITY.RESTRICTED
        },
        {
          label: 'Private',
          underlabel:
              'Only you can see this goal and progress updates. This goal cannot have subgoals.',
          value: GOAL_VISIBILITY.PRIVATE
        }
      ])
  ];

  return (
    <div className='flex justify-between'>
      <p className='mb-0 font-bold text-base text-gray-500'>GOAL PRIVACY</p>
      <div className='pl-8 pr-6 w-4/6'>
        <div className='w-full'>
          <Controller
            name='visibility'
            control={control}
            rules={{ required: true }}
            render={({ field }) => {
              const title = field.value ? field.value.label : '';

              return (
                <Select
                  classes='w-full'
                  options={options}
                  title={title}
                  optionUnderlabelClasses='!overflow-visible !text-clip !whitespace-normal text-[14px]'
                  {...field}
                  disabled={hasSubgoals}
                  onChange={(option) => setValue('visibility', option)}
                />
              );
            }}
          />
          {hasSubgoals ? (
            <p className='text-xs text-red'>
              {`You can't change privacy settings because this goal has ${children.length} subgoal${children.length > 1 ? 's' : ''}.`}
            </p>
          ) : null}
        </div>
      </div>
    </div>
  );
};

export default Visibility;
